import { DialogComponent } from '@theme/dialog';
import { CartAddEvent } from '@theme/events';

/**
 * A custom element that manages a cart drawer.
 *
 * @extends {DialogComponent}
 */
class CartDrawerComponent extends DialogComponent {
  connectedCallback() {
    super.connectedCallback();
    document.addEventListener(CartAddEvent.eventName, this.#handleCartAdd);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(CartAddEvent.eventName, this.#handleCartAdd);
  }

  #handleCartAdd = (event) => {
    console.log('🛒 CART DRAWER: cart:update EVENT RECEIVED', {
      event,
      detail: event.detail,
      hasAutoOpen: this.hasAttribute('auto-open'),
      willOpen: this.hasAttribute('auto-open'),
      stackTrace: new Error().stack
    });

    if (this.hasAttribute('auto-open')) {
      console.log('  ↳ Opening cart drawer because auto-open attribute is present');
      // this.showDialog();
      handleFloCartBtn();
    } else {
      console.log('  ↳ NOT opening cart drawer (no auto-open attribute)');
    }
  };

  open() {

    this.showDialog();

    /**
     * Close cart drawer when installments CTA is clicked to avoid overlapping dialogs
     */
    customElements.whenDefined('shopify-payment-terms').then(() => {
      const installmentsContent = document.querySelector('shopify-payment-terms')?.shadowRoot;
      const cta = installmentsContent?.querySelector('#shopify-installments-cta');
      cta?.addEventListener('click', this.closeDialog, { once: true });
    });
  }

  close() {
    this.closeDialog();
  }
}

if (!customElements.get('cart-drawer-component')) {
  customElements.define('cart-drawer-component', CartDrawerComponent);
}
